import { Result } from "./common";
import { TripLeg } from "./trip-leg";

export interface PortalLogin {
  evtPmsCode: string;
  evtUId: number;
  shpid: number;
  shpShipName: string;
  pckstart: Date;
  pckend: Date;
  rebcode: string;
  rebuid: number;
  refFolfolioId: number;
  evtBegDate: Date;
  evtEndDate: Date;
  folFullNameSal: string;
  folrepeaterno: string;
}

export interface PortalLoginList {
  Result: Result;
  PortalLoginList: PortalLogin[];
  eventLegs?: TripLeg[];
  packageStart?: Date | string;
  packageEnd?: Date | string;
}

export interface PortalLoginResponse {
  GetPortalLogin: PortalLoginList;
}

export class PortalLoginRequestBody {
  bookingCode: string | undefined;
  lastname: string | undefined;
  loyaltynumber: string | undefined;

  constructor(bookingCode: string | undefined, lastname: string | undefined, loyaltynumber: string | undefined) {
    this.bookingCode = bookingCode;
    this.lastname = lastname;
    this.loyaltynumber = loyaltynumber;
  }
}

// ---- /AX/login types ----

export interface AXLoginRequest {
  BookingCode: string;
  Surname: string;
}

export interface AXLoginData {
  rebCode: string;
  rebUid: number;
  folRepeaterNo: string;
  evtPmsCode: string;
  packageStart: string;
  packageEnd: string;
  eventLegs: TripLeg[];
}

export interface AXLoginResult {
  messageId: number;
  message: string;
  status: string;
}

export interface AXLoginResponse {
  data: AXLoginData;
  ipAddress: string | null;
  token: string;
  result: AXLoginResult;
}